import { Checkbox, Chip, Grid, TextField } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { Autocomplete } from "@mui/lab";
import React, { useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../stores/rootReducer";
import { getCompensatingFactor } from "../../stores/WaiverRequest/WaiverRequest.action";
import { updateCompensatingFactorsOptions } from "../../stores/EvaluationResults/EvaluationResults.reducer";

const icon = <CheckBoxOutlineBlankIcon fontSize="large" />;
const checkedIcon = <CheckBoxIcon fontSize="large" />;

const useStyles = makeStyles({
  chip: {
    background: "#11CEEF",
    color: "#fff",
    textTransform: "uppercase",
    height: 20,
    border: "none",
    borderRadius: 6,
    margin: 0,
    marginLeft: 8
  },
  headerText: {
    textAlign: "left",
    fontSize: "12px !important",
    fontWeight: 600,
    color: "#8897aa",
    lineHeight: 1.5,
    paddingBottom: 0
  },
  autoComplete: {
    marginBottom: "1rem",
    width: "92%",
    "&.Mui-focused *": {
      boxShadow: "none !important",
      border: "none"
    },
    "&.Mui-focused": {
      border: "1px solid rgb(136, 151, 170);",
      borderRadius: 5
    }
  },
  w100: {
    width: "100% !important"
  }
});

export const WaiversCompensatingFactors = ({
  setselectedCompensatingFactors,
  selectedCompensatingFactors,
  onCompensatingFactorClose,
  title,
  fullWidth
}: any) => {
  // const [compensatingFactorsOptions, setCompensatingFactors] = useState<any[]>([]);
  const dispatch = useDispatch();
  const { compensatingFactorsOptions } = useSelector<RootState, any>(
    (state) => state.evaluationResultsStore
  );
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const classes = useStyles();

  useEffect(() => {
    if (!compensatingFactorsOptions.length) {
      const body = {
        loanType: "",
        loanStage: "",
        userGroup: "",
        userId: ""
      };
      setIsLoading(true);
      getCompensatingFactor(body)
        .then((res: any) => {
          // setCompensatingFactors(res.data.sort());
          dispatch(updateCompensatingFactorsOptions(res.data.sort()));
          setIsLoading(false);
        })
        .catch((e) => {
          console.log(e);
          setIsLoading(false);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [compensatingFactorsOptions]);

  return (
    <>
      <Grid className={classes.headerText}>{title || `Compensating Factors (Min. 2)`}</Grid>
      <Autocomplete
        multiple
        id="asynchronous-demo"
        disableClearable
        className={`${classes.autoComplete} ${fullWidth ? classes?.w100 : ""}`}
        // onOpen={() => {
        //   openCompensatingFactors();
        // }}
        value={selectedCompensatingFactors}
        onChange={(e, key) => onCompensatingFactorClose(key)}
        getOptionLabel={(option: any) => option ?? ""}
        disableCloseOnSelect
        renderTags={(value, getTagProps) => {
          setselectedCompensatingFactors(value);
          return value.map((option, index) => (
            <Chip
              style={{
                background: "#11CEEF",
                color: "#fff",
                textTransform: "uppercase",
                height: 20,
                border: "none",
                borderRadius: 6,
                margin: 0,
                marginLeft: 8
              }}
              variant="outlined"
              label={option}
              deleteIcon={<CloseIcon style={{ height: 16 }} />}
              {...getTagProps({ index })}
            />
          ));
        }}
        loading={isLoading}
        options={compensatingFactorsOptions}
        renderOption={(props, option, { selected }) => (
          <li {...props}>
            <Checkbox
              icon={icon}
              checkedIcon={checkedIcon}
              style={{ marginRight: 8 }}
              checked={selected}
            />
            {option}
          </li>
        )}
        renderInput={(params) => (
          <TextField {...params} variant="outlined" placeholder="Select" />
        )}
      />
    </>
  );
};
